import React, { useState } from 'react';
import moment from 'moment';
import { ButtonV2, Checkbox, DatePicker } from 'components';
import './style.scss';

function CheckboxStep({ data, onToggle, nextStep, filters, onFiltersUpdate }) {
  const { startDate, endDate } = filters;
  const [error, setError] = useState('');

  const handleStartChange = date => {
    onFiltersUpdate({
      startDate: moment(date).format('YYYY-MM-DD'),
      endDate
    });
    setError('');
  };

  const handleEndChange = date => {
    onFiltersUpdate({
      startDate,
      endDate: moment(date).format('YYYY-MM-DD')
    });
    setError('');
  };

  const disableDays = day => {
    const momentDay = moment(day);
    const currentMoment = moment();
    const startMoment = moment(startDate);

    return momentDay.isAfter(currentMoment) || momentDay.isBefore(startMoment);
  };

  const disableDaysStart = day => {
    const momentDay = moment(day);
    return momentDay.isAfter(moment(endDate));
  };

  const handleContinue = () => {
    const start = moment(startDate);
    const end = moment(endDate);
    if (end.diff(start, 'months', true) > 6) {
      setError('Cannot use range that exceeds 6 months');
      return;
    }
    nextStep();
  };

  return (
    <div className="select-students-modal">
      <div className="modal__header modal__header--bordered">
        <span className="modal__header-title select-students-modal__header-title">
          Send Portfolio to Parents
          <span className="select-students-modal__steps">
            <em>Step 1</em> / 2
          </span>
        </span>
        <div className="select-students-modal__header-subtitle">
          Filter the portfolio to send only information within the specified date range. Parents will receive an email
          with a PDF of their child’s portfolio specific to the selected date range.
        </div>
      </div>

      <div className="modal__container select-students-modal__body">
        <div className="select-students-modal__date-filter" style={{ marginBottom: 16 }}>
          <div className="datepicker-container">
            <div className="datepicker-label">
              Start Date<span className="form__asterisk">*</span>
            </div>
            <DatePicker
              value={startDate ? moment(startDate).toDate() : ''}
              placeholder="Start Date"
              disabled={false}
              onChange={handleStartChange}
              disableFuture
              disableDays={disableDaysStart}
            />
          </div>
          <div className="datepicker-container">
            <div className="datepicker-label">
              End Date<span className="form__asterisk">*</span>
            </div>
            <DatePicker
              value={endDate ? moment(endDate).toDate() : ''}
              placeholder="End Date"
              disabled={false}
              onChange={handleEndChange}
              disableFuture
              disableDays={disableDays}
            />
            {error ? (
              <div className="datepicker-error">{error}</div>
            ) : (
              <div className="datepicker-info">Cannot exceed 6 months from Start Date</div>
            )}
          </div>
        </div>

        <div>
          <Checkbox
            type="square"
            size="small"
            name="withProgressOnly"
            label="Only include Assessments with an assigned Progress"
            checked={data.withProgressOnly}
            onChange={onToggle}
          />
        </div>

        <p className="pt-16 leading-tight">
          <strong>IMPORTANT: </strong>Children that have assessments but have not been marked with a progress will
          produce an empty PDF.
        </p>
      </div>

      <div className="modal__controls">
        <ButtonV2 label="Continue" onClick={handleContinue} data-cy="filter-trigger" />
      </div>
    </div>
  );
}

export default CheckboxStep;
